import React, { useContext } from "react";
import { Spin } from "antd";
import { ThemeContext } from "../contexts/ThemeContext";
import V2Spinner from "./V2Spinner";

type LoadingProps = {
  margin?: string;
  size?: "small" | "default" | "large";
  tip?: React.ReactNode;
};

/**
 * Loading Component with Custom V2 Spinner
 * A theme-aware loading component that uses the V2 custom spinner instead of AntD's default
 */
const Loading = ({ margin, size, tip }: LoadingProps) => {
  const themeContext = useContext(ThemeContext);
  const effectiveTheme = themeContext?.effectiveTheme ?? "light";
  const isDarkTheme = effectiveTheme === "dark";

  const indicator = <V2Spinner size={size} className="loading__icon" />;

  return (
    <div
      className="loading"
      style={{
        margin,
        color: isDarkTheme ? "rgba(255,255,255,0.9)" : undefined,
      }}
    >
      <Spin
        indicator={indicator}
        size={size}
        tip={tip}
        style={isDarkTheme ? { color: "rgba(255,255,255,0.9)" } : undefined}
      />
    </div>
  );
};

export default Loading;
